import useRealtimeChannel, { IProps } from 'hooks/use-realtime-channel';

const RealtimeChannel = (props: IProps) => {
  useRealtimeChannel(props);
  return null;
};

export default RealtimeChannel;
